import { render, staticRenderFns } from "./NewgameWrapperRecommend.vue?vue&type=template&id=06944d9c"
import script from "./NewgameWrapperRecommend.vue?vue&type=script&lang=js"
export * from "./NewgameWrapperRecommend.vue?vue&type=script&lang=js"
import style0 from "./NewgameWrapperRecommend.vue?vue&type=style&index=0&id=06944d9c&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports